import gql from 'graphql-tag';

export const FETCH_PATIENT_BY_EXTERNAL_ID = gql`
  query(
    $orgId: String!
    $externalId: String
    $email: String
    $title: String
    $firstName: String
    $lastName: String
    $middleName: String
    $dateOfBirth: String
    $phoneNumber: String
    $gender: Gender
    $address: String
  ) {
    getPatientByExternalId(
      orgId: $orgId
      externalId: $externalId
      email: $email
      title: $title
      firstName: $firstName
      lastName: $lastName
      middleName: $middleName
      dateOfBirth: $dateOfBirth
      phoneNumber: $phoneNumber
      gender: $gender
      address: $address
    ) {
      userId
      orgId
      type
      status
      profile {
        title
        gender
        firstName
        middleName
        lastName
        email
        phoneNumber
        externalId
        address
        description
        dateOfBirth
        firstDayOfWeek
      }
      dynamicPermissions {
        orgNodeId
        roleResources {
          resourceCode
          create
          read
          update
          delete
          assign
          children {
            resourceCode
            create
            read
            update
            delete
            assign
          }
        }
      }
    }
  }
`;
